module.exports = __webpack_public_path__ + "static/media/placeholder.ce5b54c9.jpg";